interface AmplifyEnv {
  REGION: string;
  USER_POOL_ID: string;
  USER_POOL_WEB_CLIENT_ID: string;
  IDENTITY_POOL_ID: string;
  USER_POOL_DOMAIN: string;
  FEDERATED_REDIRECT_SIGNIN: string;
}

let config: AmplifyEnv = {
  REGION: '',
  USER_POOL_ID: '',
  USER_POOL_WEB_CLIENT_ID: '',
  IDENTITY_POOL_ID: '',
  USER_POOL_DOMAIN: '',
  FEDERATED_REDIRECT_SIGNIN: '',
};

try {
  const envConfig = process.env.REACT_APP_AMPLIFY_CONFIG;
  if (envConfig) {
    config = JSON.parse(envConfig);
  } else {
    console.error('REACT_APP_AMPLIFY_CONFIG is not set.');
  }
} catch (e) {
  console.error('Invalid REACT_APP_AMPLIFY_CONFIG format:', e);
}

export const authConfig = {
  Auth: {
    Cognito: {
      userPoolId:  config.USER_POOL_ID,
      userPoolClientId: config.USER_POOL_WEB_CLIENT_ID,
      identityPoolId: config.IDENTITY_POOL_ID,
      loginWith: {
        email: true,
      },
    mandatorySignIn: true,
    region: config.REGION,
  },
  oauth: {
    domain: config.USER_POOL_DOMAIN,
    scope: ['email', 'openid'],
    redirectSignIn: config.FEDERATED_REDIRECT_SIGNIN,
    redirectSignout: config.FEDERATED_REDIRECT_SIGNIN,
    responseType: 'token',
  },
}
}
